import React from 'react';
import { Input, InputProps } from './Input';
export interface DatePickerProps extends Omit<InputProps, 'type'> {
  value?: string;
  onChange?: (date: string) => void;
}
export function DatePicker({
  value,
  onChange,
  ...props
}: DatePickerProps) {
  return <Input type="date" value={value} onChange={e => onChange?.(e.target.value)} {...props} data-id="element-231" />;
}